import LText from "@components/LText";
import LBox from "@components/LBox";
import { NumberSelector } from "./NumberSelector";
import { PayWhatYouWant } from "./PayWhatYouWant";
import { Dispatch, SetStateAction } from "react";
import { storeMoney } from "@libs/platform-wire";

export default function Ticket({
  title = "Ticket Tier 1",
  price,
  priceMax,
  bookingFee,
  numberOfTickets,
  setNumberOfTickets,
  setSelectedPrice,
}: {
  title?: string;
  price: number | null;
  priceMax: number | null | undefined;
  bookingFee?: number | null;
  numberOfTickets: number;
  setNumberOfTickets: Dispatch<SetStateAction<number>>;
  setSelectedPrice: Dispatch<SetStateAction<number>>;
}) {
  // The price with its booking fee (matching Entry.tsx pattern)
  const displayPrice = (price ?? 0) + (bookingFee ?? 0);
  const shouldShowPrice = price !== null;

  return (
    <LBox gap="s3">
      <LBox
        padding="s4"
        borderRadius="m-l"
        backgroundColor="whiteTranslucent10"
        gap="s2"
      >
        <LBox
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <LBox gap="s3">
            <LText variant="Body/B1/Medium" fontWeight="bold">
              {title}
            </LText>
            {shouldShowPrice ? (
              <LText variant="Body/B1/Regular" color="whiteTranslucent50">
                {displayPrice > 0 ? storeMoney(displayPrice, "GBP") : "FREE"}
              </LText>
            ) : null}
          </LBox>
          <NumberSelector
            number={numberOfTickets}
            setNumber={setNumberOfTickets}
          />
        </LBox>

        <PayWhatYouWant
          price={price}
          priceMax={priceMax}
          bookingFee={bookingFee}
          onPriceChange={setSelectedPrice}
        />
      </LBox>
    </LBox>
  );
}
